import React, { useState } from 'react';

const LogEntries = ({ entityId, entityType, logs, onAddLog, onDeleteLog, currentUser }) => {
    const [newLog, setNewLog] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!newLog.trim()) return;

        onAddLog({
            entityId,
            entityType,
            content: newLog,
            timestamp: new Date().toISOString()
        });
        setNewLog('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent.isComposing) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        <div className="log-entries">
            <form onSubmit={handleSubmit} className="mb-3">
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        value={newLog}
                        onChange={(e) => setNewLog(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder="Add a note..."
                    />
                    <button 
                        type="submit" 
                        className="btn btn-link" 
                        disabled={!newLog.trim()}
                    >
                        <svg 
                            width="16" 
                            height="16" 
                            fill="currentColor" 
                            viewBox="0 0 16 16"
                        >
                            <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"/>
                        </svg>
                    </button>
                </div>
            </form>

            <div className="log-entries-list">
                {logs.length === 0 ? (
                    <span></span>
                ) : (
                    logs.map((log, index) => (
                        <div key={log.id || index} className="log-entry mb-2">
                            <div className="d-flex justify-content-between align-items-start">
                                <small className="text-muted">
                                    {log.userName || `${log.firstName} ${log.lastName}`} - 
                                    {new Date(log.timestamp).toLocaleString()}
                                </small>
                                <button
                                    className="btn btn-link text-danger p-0 ms-2 delete-btn"
                                    onClick={() => onDeleteLog(log.id)}
                                    title="Delete note"
                                >
                                    ×
                                </button>
                            </div>
                            <div className="log-content">{log.content}</div>
                            <hr className="my-2" />
                        </div>
                    ))
                )}
            </div>

            <style>{`
                .log-entries {
                    max-height: 300px;
                    overflow-y: auto;
                }
                .log-entry {
                    padding: 0.5rem;
                    background-color: #f8f9fa;
                    border-radius: 4px;
                }
                .log-content {
                    margin-top: 0.25rem;
                    white-space: pre-wrap;
                }
                .delete-btn {
                    font-size: 1.5rem;
                    line-height: 1;
                    text-decoration: none;
                    opacity: 0.5;
                }
                .delete-btn:hover {
                    text-decoration: none;
                    opacity: 1;
                }
                .btn-link {
                    color: #6c757d;
                }
                .btn-link:hover {
                    color: #0d6efd;
                }
                .btn-link:disabled {
                    opacity: 0.3;
                }
            `}</style>
        </div>
    );
};

export default LogEntries;